import { useContext, type ReactElement } from 'react'
import { Outlet } from 'react-router-dom'
import NoPermissionsPage from '../pages/common/NoPermissionsPage'
import KeycloakContext from '../auth/KeycloakContext'

interface Props {
  roles: string[]
}

const ProtectedRoute = ({ roles }: Props): ReactElement | null => {
  const { keycloak } = useContext(KeycloakContext)

  if (keycloak !== undefined) {
    const auth = keycloak.authenticated // determine if authorized, from context or however you're doing it
    if (auth === false) {
      window.location.href = keycloak.createLoginUrl()
      return null
    }

    const hasPermissions = roles.find((role) => keycloak.hasRealmRole(role))
    return hasPermissions !== null ? <Outlet /> : <NoPermissionsPage />
  }

  return <NoPermissionsPage />
}

export default ProtectedRoute
